import { render, staticRenderFns } from "./SettingMenuIndex.vue?vue&type=template&id=65521642&scoped=true&"
import script from "./SettingMenuIndex.vue?vue&type=script&lang=js&"
export * from "./SettingMenuIndex.vue?vue&type=script&lang=js&"
import style0 from "./SettingMenuIndex.vue?vue&type=style&index=0&id=65521642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65521642",
  null
  
)

export default component.exports